<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card grid-list-md>
      <ModelTitle :title="Student.CustomerId ? 'Move Student' : 'Assign Parent'" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-autocomplete dense autofocus hide-details :items="Customers" item-text="name"
            v-model="selectedCustomer" return-object label="Select Parent" outlined />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" :disabled="!selectedCustomer" text @click="moveStudent()">
          {{ Student.CustomerId ? "Move Student" : "Assign Parent" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import studentService from "@/modules/Student/service.js";
import customerService from "@/modules/Customer/service.js";

export default {
  name: "move-Student",
  props: {
    moveStudentDialog: {
      default: false,
    },
    student: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      selectedCustomer: null,
      Student: {},
      Customers: [],
    };
  },
  watch: {
    moveStudentDialog(val) {
      this.Student = { ...this.student };
      this.dialog = val;
      if(val){
        this.getCustomers();
      }
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Student = {};
      this.selectedCustomer = null;
    },
    getCustomers() {
      return customerService.getAll().then((response) => {
        this.Customers = response.data;
        this.Customers.map(row => {
          if (this.Student.CustomerId === row.id) {
            this.selectedCustomer = row
          }
        })
        return response;
      });
    },
    moveStudent() {
      if (!this.selectedCustomer || !this.selectedCustomer.id) return;
      this.loading = true;
      return studentService
        .update(this.Student.id, { CustomerId: this.selectedCustomer.id })
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Student is moved",
              });
            this.loading = false;
            this.$emit("submit");
            this.close();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
  },
};
</script>

<style scoped>
</style>
